import { render, staticRenderFns } from "./AllEscalations.vue?vue&type=template&id=abe5b324&"
import script from "./AllEscalations.vue?vue&type=script&lang=ts&"
export * from "./AllEscalations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports